import isPremium from './isPremium';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFakeFreeConsumerTestFlightOn } from './isFakeFreeConsumerTestFlightOn';

export function shouldShowUpsell() {
    return (isConsumer() && !isPremium()) || isFakeFreeConsumerTestFlightOn();
}
